import React from "react";
import { Button, TextField, Grid, CircularProgress } from "@mui/material";
// import Abhaicons from "../../Images/Adharicon.svg";
// import Abhashiled from "../../Images/material-symbols-light_shield-outline.svg";

const Step2OtpMobileVerification = ({
  isLoading,
  otp,
  setOtp,
  mobile,
  setMobile,
  mobileOtp,
  setMobileOtp,
  showMobileOtpStep,
  onVerifyAadhaarOtp,
  onVerifyMobileOtp,
  onResendAadhaarOtp,
  onResendMobileOtp,
  // Aadhaar OTP Timer Props
  aadhaarCanResend = true,
  aadhaarFormattedTime = "01:00",
  aadhaarResendCount = 0,
  aadhaarMaxResendCount = 2,
  // Mobile OTP Timer Props
  mobileCanResend = true,
  mobileFormattedTime = "01:00",
  mobileResendCount = 0,
  mobileMaxResendCount = 2,
}) => {
  // Format OTP input
  const handleOtpChange = (e, setFunction) => {
    let value = e.target.value.replace(/\D/g, ""); // Only digits
    if (value.length > 6) value = value.slice(0, 6);
    setFunction(value);
  };

  // Format Mobile input
  const handleMobileChange = (e) => {
    let value = e.target.value.replace(/\D/g, ""); // Only digits
    if (value.length > 10) value = value.slice(0, 10);
    setMobile(value);
  };

  // Validations
  const isOtpValid = otp.length === 6;
  const isMobileValid = /^[6-9]\d{9}$/.test(mobile);
  const isMobileOtpValid = mobileOtp.length === 6;
  const isAadhaarVerifyEnabled = isOtpValid && isMobileValid;

  return (
    <div className="text-center">
      <img src="/images/abdm/Adharicon.svg" alt="ABHA Icon" />
      <h5 className="sub-text">OTP Verification</h5>
      <p className="sub-para">
        Enter the 6-digit OTP sent to your registered Aadhaar mobile number
      </p>

      {!showMobileOtpStep ? (
        <>
          {/* Aadhaar OTP Input */}
          <div className="otp-container" style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
            {[0, 1, 2, 3, 4, 5].map((index) => (
              <TextField
                key={index}
                inputRef={(el) => {
                  if (!window.aadhaarOtpRefs) window.aadhaarOtpRefs = [];
                  window.aadhaarOtpRefs[index] = el;
                }}
                inputProps={{
                  style: { textAlign: 'center', fontSize: '24px', padding: '14px', height: '1em' },
                  maxLength: 1
                }}
                value={otp[index] || ''}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "");
                  if (value) {
                    const newOtp = otp.split('');
                    newOtp[index] = value;
                    setOtp(newOtp.join(''));
                    // Auto-focus next box
                    if (index < 5 && window.aadhaarOtpRefs[index + 1]) {
                      window.aadhaarOtpRefs[index + 1].focus();
                    }
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Backspace') {
                    const newOtp = otp.split('');
                    if (newOtp[index]) {
                      // Delete current digit
                      newOtp[index] = '';
                      setOtp(newOtp.join(''));
                    } else if (index > 0 && window.aadhaarOtpRefs[index - 1]) {
                      // Move to previous box if current is empty
                      window.aadhaarOtpRefs[index - 1].focus();
                    }
                  }
                }}
                sx={{
                  width: '50px',
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '8px'
                  }
                }}
              />
            ))}
          </div>

          {/* Mobile Number Input */}
          <Grid container spacing={2} className="mt-2">
            <Grid size={{ xs: 12, md: 12 }}>
              <TextField
                label="Mobile Number"
                variant="outlined"
                fullWidth
                size="small"
                value={mobile}
                onChange={handleMobileChange}
                placeholder="Enter 10-digit mobile number"
                inputProps={{
                  maxLength: 10,
                  inputMode: "numeric",
                }}
                error={mobile.length > 0 && !isMobileValid}
                helperText={
                  mobile.length > 0 && !isMobileValid
                    ? "Please enter a valid 10-digit mobile number"
                    : "It is preferable to use your Aadhaar-linked mobile number. If you choose to use a different mobile number, it will need to be validated again and will be used for all communication related to ABHA."
                }
              />
            </Grid>
          </Grid>

          {/* Verify Button */}
          <div className="d-flex justify-content-between mt-3">
            <Button
              variant="contained"
              fullWidth
              className={`send-otp-btn ${isAadhaarVerifyEnabled ? "active" : ""}`}
              disabled={!isAadhaarVerifyEnabled}
              onClick={onVerifyAadhaarOtp}
            > 
              {isLoading ? <CircularProgress size={24} color="inherit" /> : "Verify OTP"}
            </Button>
          </div>

          {/* Resend OTP */}
          <div className="d-flex justify-content-between align-items-center mt-3" style={{ fontSize: '0.9rem' }}>
            <span style={{ color: '#666' }}>Didn't receive OTP?</span>
            <div className="d-flex align-items-center gap-3">
              <button
                onClick={async () => {
                  try {
                    await onResendAadhaarOtp();
                  } catch (error) {
                    console.error('Failed to resend OTP:', error);
                  }
                }}
                disabled={!aadhaarCanResend}
                style={{
                  background: 'none',
                  border: 'none',
                  color: aadhaarCanResend ? '#155DFC' : '#999',
                  cursor: aadhaarCanResend ? 'pointer' : 'not-allowed',
                  textDecoration: aadhaarCanResend ? 'underline' : 'none',
                  fontWeight: 500,
                  padding: 0
                }}
              >
                Resend OTP ({aadhaarResendCount}/{aadhaarMaxResendCount})
              </button>
            </div>
            <span style={{ color: '#666', fontSize: '0.85rem' }}>
              {aadhaarFormattedTime} remaining
            </span>
          </div>
        </>
      ) : (
        <>
          {/* Mobile OTP Sub-Step */}
          <p className="sub-para mt-3">
            Your mobile number is different from Aadhaar registered number. Please verify your mobile number.
          </p>

          <div className="otp-container" style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
            {[0, 1, 2, 3, 4, 5].map((index) => (
              <TextField
                key={index}
                inputRef={(el) => {
                  if (!window.mobileOtpRefs) window.mobileOtpRefs = [];
                  window.mobileOtpRefs[index] = el;
                }}
                inputProps={{
                  style: { textAlign: 'center', fontSize: '24px', padding: '14px', height: '1em' },
                  maxLength: 1
                }}
                value={mobileOtp[index] || ''}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "");
                  if (value) {
                    const newOtp = mobileOtp.split('');
                    newOtp[index] = value;
                    setMobileOtp(newOtp.join(''));
                    // Auto-focus next box
                    if (index < 5 && window.mobileOtpRefs[index + 1]) {
                      window.mobileOtpRefs[index + 1].focus();
                    }
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Backspace') {
                    const newOtp = mobileOtp.split('');
                    if (newOtp[index]) {
                      // Delete current digit
                      newOtp[index] = '';
                      setMobileOtp(newOtp.join(''));
                    } else if (index > 0 && window.mobileOtpRefs[index - 1]) {
                      // Move to previous box if current is empty
                      window.mobileOtpRefs[index - 1].focus();
                    }
                  }
                }}
                sx={{
                  width: '50px',
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '8px'
                  }
                }}
              />
            ))}
          </div>

          {/* Verify Mobile OTP Button */}
          <div className="d-flex justify-content-between mt-3">
            <Button
              variant="contained"
              fullWidth
              className={`verify-otp-btn ${isMobileOtpValid ? "active" : ""}`}
              disabled={!isMobileOtpValid}
              onClick={onVerifyMobileOtp}
            >
              {isLoading ? <CircularProgress size={24} color="inherit" /> : "Verify Mobile OTP"}
            </Button>
          </div>

          {/* Resend Mobile OTP */}
          <div className="d-flex justify-content-between align-items-center mt-3" style={{ fontSize: '0.9rem' }}>
            <span style={{ color: '#666' }}>Didn't receive OTP?</span>
            <div className="d-flex align-items-center gap-3">
              <button
                onClick={async () => {
                  try {
                    await onResendMobileOtp();
                  } catch (error) {
                    console.error('Failed to resend OTP:', error);
                  }
                }}
                disabled={!mobileCanResend}
                style={{
                  background: 'none',
                  border: 'none',
                  color: mobileCanResend ? '#155DFC' : '#999',
                  cursor: mobileCanResend ? 'pointer' : 'not-allowed',
                  textDecoration: mobileCanResend ? 'underline' : 'none',
                  fontWeight: 500,
                  padding: 0
                }}
              >
                Resend Mobile OTP ({mobileResendCount}/{mobileMaxResendCount})
              </button>
            </div>
            <span style={{ color: '#666', fontSize: '0.85rem' }}>
              {mobileFormattedTime} remaining
            </span>
          </div>
        </>
      )}

      <div className="para-ofadhar">
        <span>
          <img src={"/images/abdm/material-symbols-light_shield-outline.svg"} alt="Shield" />
        </span>
        <p>
          Your AADHAAR details will not be stored. OTP will be sent to your registered mobile number for ABHA creation.
        </p>
      </div>
    </div>
  );
};

export default Step2OtpMobileVerification;